// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1252":"2c16765d4842f423","7860":"1352186d689eb22d"}[chunkId] + ".css";
};